import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function ListUnordered({ color = 'white', ...props }: Props) {
  return (
    <svg
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58333 1C2.58333 0.58579 2.91912 0.250003 3.33333 0.250003L11.3333 0.250004C11.7475 0.250004 12.0833 0.58579 12.0833 1C12.0833 1.41422 11.7475 1.75 11.3333 1.75L3.33333 1.75C2.91912 1.75 2.58333 1.41422 2.58333 1ZM3.33333 4.25C2.91912 4.25 2.58333 4.58579 2.58333 5C2.58333 5.41422 2.91912 5.75 3.33333 5.75L11.3333 5.75C11.7475 5.75 12.0833 5.41422 12.0833 5C12.0833 4.58579 11.7475 4.25 11.3333 4.25L3.33333 4.25ZM3.33333 8.25C2.91912 8.25 2.58333 8.58579 2.58333 9C2.58333 9.41422 2.91912 9.75 3.33333 9.75L11.3333 9.75C11.7475 9.75001 12.0833 9.41422 12.0833 9.00001C12.0833 8.58579 11.7475 8.25001 11.3333 8.25L3.33333 8.25ZM0.666666 1.66667C1.03486 1.66667 1.33333 1.36819 1.33333 1C1.33333 0.631812 1.03486 0.333335 0.666666 0.333335C0.298477 0.333335 -2.52726e-07 0.631812 -2.62269e-07 1C-2.71812e-07 1.36819 0.298476 1.66667 0.666666 1.66667ZM1.33333 5C1.33333 5.36819 1.03486 5.66667 0.666666 5.66667C0.298476 5.66667 -1.01493e-06 5.36819 -9.45777e-07 5C-8.76629e-07 4.63181 0.298476 4.33334 0.666666 4.33334C1.03486 4.33333 1.33333 4.63181 1.33333 5ZM0.666665 9.66667C1.03485 9.66667 1.33333 9.36819 1.33333 9C1.33333 8.63181 1.03485 8.33334 0.666665 8.33334C0.298475 8.33334 -1.56014e-06 8.63181 -1.62929e-06 9C-1.69843e-06 9.36819 0.298475 9.66667 0.666665 9.66667Z"
        fill={color}
      />
    </svg>
  );
}
